import StringToBoolean from "@reflexions/string-to-boolean";

export default StringToBoolean;
